import { PressureIndexConfig } from "@data-types/sport-stats/SportStatsTypes";
import { DeviceDetector } from "@utils";

export const chartConfig = {
	chart: {
		backgroundColor: "transparent",
		zoomType: false,
		type: "column",
		spacing: [0, 0, 0, 0],
		spacingBottom: 0,
		marginBottom: 0,
		height: DeviceDetector.isMobileTheme ? "100px" : "150px",
	},
	title: {
		text: undefined,
	},
	xAxis: {
		title: undefined,
		lineWidth: 0,
		labels: {
			enabled: false,
		},
	},
	yAxis: {
		gridLineWidth: 0,
		plotBands: [
			{
				from: 0,
				to: 150,
				color: "transparent",
			},
			{
				from: -150,
				to: 0,
				color: "transparent",
			},
		],
		plotLines: [
			{
				from: -0.5,
				to: 0.5,
				color: "#C6C6C6",
				zIndex: 20,
			},
		],
		lineWidth: 1,
		labels: {
			enabled: false,
		},
		title: undefined,
	},
	credits: {
		enabled: false,
	},
	plotOptions: {
		column: {
			borderWidth: 0,
			colorByPoint: true,
			maxPointWidth: 50,
			pointPadding: 0.1,
			groupPadding: 0.1,
		},
	},
	legend: {
		enabled: false,
	},
};

export const defaultConfig: PressureIndexConfig = {
	periodDuration: null,
	periods: null,
	extraTime: false,
	overtimePeriodDuration: null,
	overtimePeriods: null,
	valueYMax: 100,
	valueKey: "value",
	progressKey: "minute",
	startingKeys: {
		minute: 1,
	},
};

export const soccer: PressureIndexConfig = {
	...defaultConfig,
	periodDuration: 45,
	periods: 2,
	extraTime: true,
	overtimePeriodDuration: 15,
	overtimePeriods: 2,
	startingKeys: {
		minute: 1,
	},
};

export const statisticsKeys: { [key: string]: string } = {
	finalThirdPhaseStatistic: "FTPS",
	finalThirdEntries: "1/3",
	totalShotsOnGoal: "Total",
	bigChanceCreated: "BCC",
	goalkeeperSaves: "GKS",
	bigChanceMissed: "BCM",
	accuratePasses: "AC",
	ballPossession: "BP",
	shotsOnTarget: "Shots",
	expectedGoals: "xG",
	cornerKicks: "CK",
	totalTackle: "TM",
	yellowCards: "YC",
	totalShots: "Total",
	bigChances: "BC",
	possesion: "Poss%",
	offSide: "OFF",
	fouls: "Foul",
	passes: "Pass",
	shotsOnGoal: "SOG",
	hitWoodwork: "HWW",
	shotsOffGoal: "SOffG",
	blockedScoringAttempt: "BS",
	totalShotsInsideBox: "SITB",
	totalShotsOutsideBox: "SOTB",
	bigChanceScored: "BCS",
	accurateThroughBall: "ATB",
	touchesInOppBox: "TITOB",
	fouledFinalThird: "FFT",
	offsides: "OFF",
	throwIns: "TI",
	accurateLongBalls: "ALB",
	accurateCross: "ACR",
	duelWonPercent: "DW",
	dispossessed: "DP",
	groundDuelsPercentage: "GDP",
	aerialDuelsPercentage: "ADW",
	dribblesPercentage: "SD",
	wonTacklePercent: "WTP",
	interceptionWon: "IW",
	ballRecovery: "BR",
	totalClearance: "TC",
	goalsPrevented: "GP",
	goalKicks: "GK",
	freeKicks: "FK",
	penalties: "PK",
	redCards: "RC",
	passesOwnHalf: "POH",
	dangerousAttack: "DA",
	blocks: "BLK",
};
